import axios from 'axios';
import { print } from 'graphql';
import getEnvironmentVariable from 'util/getEnviromentVariable';
import { apiSelector } from 'components/ApiSwitch/ApiSwitch.const';

const graphqlEndpoint = getEnvironmentVariable('GRAPH_QL_ENDPOINT', apiSelector.UNIVERSAL_API);
const graphqlApiKey = getEnvironmentVariable('GRAPH_QL_API_KEY', apiSelector.UNIVERSAL_API);
export const profile = process.env.REACT_APP_GRAPH_QL_PROFILE;

const graphQLRequest = axios.create({
  baseURL: graphqlEndpoint,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'x-api-key': graphqlApiKey,
    profile,
  },
});

async function request({ query, variables = {}, cache = false, usePost = false, token = '' }) {
  const params = {
    query: print(query),
    variables,
  };

  const authConfig = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  const requestConfig = {
    cache,
    ...authConfig,
  };

  if (usePost) {
    return graphQLRequest.post('/', params, requestConfig);
  }
  return graphQLRequest.get('/', {
    ...requestConfig,
    params,
  });
}

export async function queryRequest(props) {
  const response = await request(props);
  const {
    data: { errors },
  } = response;
  if (errors && errors[0]) {
    throw new Error(errors[0].message);
  }
  return response.data;
}
